var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransferPatient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 76 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 31c0-6.778 5.495-12.273 12.273-12.273S25.546 24.222 25.546 31",
    stroke: "#5F6A7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M13.273 16a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
    stroke: "#5F6A7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.091 31c0-6.778 5.495-12.273 12.273-12.273S74.637 24.222 74.637 31",
    stroke: "#5F6A7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M62.364 16a7.5 7.5 0 100-15 7.5 7.5 0 000 15z",
    stroke: "#5F6A7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.546 10.818l6.179 6.179-6.179 6.163m-8.091-6.163H44.52",
    stroke: "#5F6A7D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNzYgMzIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEgMzFjMC02Ljc3OCA1LjQ5NS0xMi4yNzMgMTIuMjczLTEyLjI3M1MyNS41NDYgMjQuMjIyIDI1LjU0NiAzMSIgc3Ryb2tlPSIjNUY2QTdEIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuMjczIDE2YTcuNSA3LjUgMCAxIDAgMC0xNSA3LjUgNy41IDAgMCAwIDAgMTV6IiBzdHJva2U9IiM1RjZBN0QiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48cGF0aCBkPSJNNTAuMDkxIDMxYzAtNi43NzggNS40OTUtMTIuMjczIDEyLjI3My0xMi4yNzNTNzQuNjM3IDI0LjIyMiA3NC42MzcgMzEiIHN0cm9rZT0iIzVGNkE3RCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPjxwYXRoIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYyLjM2NCAxNmE3LjUgNy41IDAgMSAwIDAtMTUgNy41IDcuNSAwIDAgMCAwIDE1eiIgc3Ryb2tlPSIjNUY2QTdEIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PHBhdGggZD0iTTM4LjU0NiAxMC44MThsNi4xNzkgNi4xNzktNi4xNzkgNi4xNjNtLTguMDkxLTYuMTYzSDQ0LjUyIiBzdHJva2U9IiM1RjZBN0QiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=";
export { SvgTransferPatient as ReactComponent };